/** @format */
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import React, { Fragment } from 'react';
import styled from 'styled-components';

import InfoIcon from '@toucan/client/global/icons/info.svg';

import { useTooltip } from '@toucan/client/shared/hooks/use-tooltip';

import { useRenderTooltipContent } from './hooks/use-render-tooltip-content';
import { useUspSlugToText } from './hooks/use-usp-slug-to-text';
import { UspTooltipGlobalStyles, styles } from './usp-tag.styles';

const StyledUspTag = styled('div')`
    ${styles()}
`;

const UspTag = ({ tag }: { tag: string }) => {
    const formattedTagText = useUspSlugToText(tag);
    const dataId = `usp__${
        tag === 'low-shutter-count' ? 'great-shutter-count' : tag
    }`;
    const [bindToolTip, Tooltip, openTooltip, closeTooltip] =
        useTooltip<HTMLDivElement>({
            id: 'usp-tag-tooltip',
            manual: true,
            closeOnClickAway: true,
            onClickAway: () => closeTooltip(),
        });

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        openTooltip();
    };

    return (
        <Fragment>
            <UspTooltipGlobalStyles />
            <StyledUspTag
                data-testid="usp-tag"
                {...bindToolTip}
                onMouseEnter={openTooltip}
                onMouseLeave={closeTooltip}
                onClick={handleClick}
                data-id={dataId}
            >
                <div className="icon-container">
                    <Icon
                        size={IconSize.XS}
                        variant={IconVariant.DECORATIVE}
                        className="icon"
                        data-testid="info-icon"
                    >
                        <InfoIcon />
                    </Icon>
                </div>
                <div className="usp-tag">{formattedTagText}</div>
                <Tooltip className="usp-tooltip" data-testid="usp-tag-tooltip">
                    {useRenderTooltipContent(tag)}
                </Tooltip>
            </StyledUspTag>
        </Fragment>
    );
};

export default UspTag;
